import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {DateAxis, LabelBullet} from "@amcharts/amcharts4/charts";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";

declare var ko: any;


export class googleOverview_template extends vnTemplate {

    public filterBrands: multipleSelector_template;
    public filterSources: multipleSelector_template;
    public filterDates: filterDate_template;
    public filterComparisonDates: filterDate_template;

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;

    readonly viewModes = [

        {"id": "trends", "name": "Trends"},
        {"id": "comparison", "name": "Comparison"},
        {"id": "daily", "name": "Daily"},
    ];

    readonly viewMethods = [

        {"id": "periods", "name": "Periods"},
        {"id": "aggregated", "name": "Aggregated"},
    ];

    readonly dateLevels = [

        {"id": "day", "name": "Day"},
        {"id": "week", "name": "Week"},
        {"id": "month", "name": "Month"},
    ];

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header w-justify" data-bind="visible: hasGoogleOverviewReportReadPermission()">
            
                ` + this.presetFilter.getHtmlBuild() + `
           
                <div class="w-left">
                    <div class="dropdown select-single">
                        <label class="form-label" for="">View Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: viewModes">
                                    <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'comparison'">
                        <label class="form-label" for="">View Method</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewMethodSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: viewMethods">
                                    <input type="radio" data-bind="checked : $parent.viewMethodSelected, value: id,  attr: { 'id': 'viewMethod_' + id, 'name' : 'viewMethod_' + id }, event:{ change: $parent.onViewMethodChange}">
                                    <label class="form-label" data-bind="attr: {for : 'viewMethod_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'trends' || viewModeSelected() == 'comparison'">
                        <label class="form-label" for="">Date Level</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dateLevelSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: dateLevels">
                                    <input type="radio" data-bind="checked : $parent.dateLevelSelected, value: id,  attr: { 'id': 'dateLevel_' + id, 'name' : 'dateLevel_' + id }, event:{ change: $parent.onDateLevelChange}">
                                    <label class="form-label" data-bind="attr: {for : 'dateLevel_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'daily'">
                        <label class="form-label" for="">Date Level</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dailyDateLevelSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: dailyDateLevels">
                                    <input type="radio" data-bind="checked : $parent.dailyDateLevelSelected, value: id,  attr: { 'id': 'dailyDateLevel_' + id, 'name' : 'dailyDateLevel_' + id }, event:{ change: $parent.onDailyDateLevelChange}">
                                    <label class="form-label" data-bind="attr: {for : 'dailyDateLevel_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div data-bind="visible: viewModeSelected() == 'trends' || viewModeSelected() == 'comparison' || viewModeSelected() == 'daily'">
                        ${this.filterBrands.getHtmlBuild()}
                    </div>

                    <div data-bind="visible: viewModeSelected() == 'trends' || viewModeSelected() == 'comparison' || viewModeSelected() == 'daily'">
                        ${this.filterSources.getHtmlBuild()}
                    </div>

                    <div data-bind="visible: viewModeSelected() == 'trends' || viewModeSelected() == 'comparison' || viewModeSelected() == 'daily'">
                        ${this.filterDates.getHtmlBuild()}
                    </div>

                    <div data-bind="css: {disabledDiv: !isVisibleComparisonDates()}, visible: viewModeSelected() == 'comparison'">
                        ${this.filterComparisonDates.getHtmlBuild()}
                    </div>
                    
                    <div class="form-check-inline" data-bind="visible: viewModeSelected() == 'comparison'">
                        <input id="checkComparisonDates" name="isVisibleComparisonDates" data-bind="event: {change: onToggleComparisonDates}, checked: isVisibleComparisonDates" type="checkbox">
                        <label for="checkComparisonDates" class="form-label icon i-check">Enable Comparison</label>
                    </div>
                </div>
          
            </div>

            <!-- ko if: hasGoogleOverviewReportReadPermission -->
            ` + this.validationsList.getHtmlBuild() + `
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div data-bind="visible: viewModeSelected() == 'trends' || viewModeSelected() == 'comparison' || viewModeSelected() == 'daily'" id="selected-brands"></div>
                    <div data-bind="visible: viewModeSelected() == 'trends' || viewModeSelected() == 'comparison'" id="selected-sources"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-google" data-bind="visible: (viewModeSelected() == 'daily')">Google Clicks Overview</h2>
                    <h2 class="section-title icon i-google" data-bind="visible: (viewModeSelected() == 'trends')">Click Trends by Brand</h2>
                    <h2 class="section-title icon i-google" data-bind="visible: (viewModeSelected() == 'comparison' && viewMethodSelected() == 'periods')">Clicks by Period Comparison</h2>
                    <h2 class="section-title icon i-google" data-bind="visible: (viewModeSelected() == 'comparison' && viewMethodSelected() == 'aggregated')">Average Clicks by Weekday Comparison</h2>
                </div>
            </div>
            
            <section class="w-graph google-overview"  data-bind="visible: viewModeSelected() == 'comparison' || viewModeSelected() == 'trends', css: { loading: isChartLoading }">
                <!-- ko foreach: graphs -->
                    <div class="graph">
                        <!-- ko if: $data.brand -->
                            <div class="graph-header brand-logo" data-bind="using: brand">
                                <span class="brand-logo" data-bind="css: iconImage, text: name"></span>
                            </div>
                        <!-- /ko -->

                        <!-- ko if: ($parent.viewModeSelected() == 'comparison' && $parent.viewMethodSelected() == 'aggregated') -->
                        <div data-bind="template: { name: 'amCharts_v4_category_line_template', data: $data.graph.getTemplateViewModel() }"></div>
                        <!-- /ko -->
                    </div>
                <!-- /ko -->

                <!-- ko foreach: dateGraphs -->
                    <div class="graph">
                        <!-- ko if: ($parent.viewModeSelected() == 'comparison' && $parent.viewMethodSelected() == 'periods') || $parent.viewModeSelected() == 'trends' -->
                        <div data-bind="template: { name: 'amCharts_v4_date_line_template', data: $data.graph.getTemplateViewModel() }"></div>
                        <!-- /ko -->
                    </div>
                <!-- /ko -->
            </section>
            
            <div id="list-results"  data-bind="visible: viewModeSelected() == 'daily'" style="position: relative">
                <div class="w-sticky-col" >
                    <table class="list-results list-sections" >
                        <thead>
                            <!-- ko foreach: headers -->
                                <tr class="list-header-section">
                                <!-- ko foreach: $data -->
                                    <th data-bind="attr: { colspan: $data.cols || 1}, css: $data.class || ''"><span data-bind="text: label"></span></th>
                                 <!-- /ko -->
                                 </tr>
                            <!-- /ko -->
                        </thead>
                        <tbody>
                            <!-- ko foreach: tableData -->
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                <!-- ko with: $parents[0].headers()[$parents[0].headers().length-1] -->
                                    <!-- ko foreach: $data -->
                                        <td data-bind="attr: {'class': $data.class || ''}, css: {'stick-col' : $index() === 0}"><span class="align-right" data-bind="text: $parents[1][$data.key]"></span></td>
                                    <!-- /ko -->
                                <!-- /ko -->
                                </tr>
                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- /ko -->
            `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('googleOverview');

        this.filterBrands = new multipleSelector_template("filterBrands", this.getTemplateViewModel(), this.caller);
        this.filterBrands.setTagContainerId('selected-brands');
        this.filterBrands.setTagContainerCaption('Selected brands:');
        this.filterBrands.setLogoEnabled(true);

        this.filterSources = new multipleSelector_template("filterSources", this.getTemplateViewModel(), this.caller);
        this.filterSources.setTagContainerId('selected-sources');
        this.filterSources.setTagContainerCaption('Selected sources:');

        this.filterDates = new filterDate_template("filterDates", this.getTemplateViewModel(), this.caller);
        this.filterDates.setStartPickerId('startDate');
        this.filterDates.setEndPickerId('endDate');

        this.filterComparisonDates = new filterDate_template("filterComparisonDates", this.getTemplateViewModel(), this.caller);
        this.filterComparisonDates.setStartPickerId('comparisonStartDate');
        this.filterComparisonDates.setEndPickerId('comparisonEndDate');

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    protected getTemplateName(): string {

        return "googleOverview_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            titleDate: ko.observable("")
            , headers: ko.observableArray([])
            , tableData: ko.observableArray([])
            , viewModes: ko.observableArray([])
            , viewModeSelected: ko.observable("trends")
            , viewMethods: ko.observableArray([])
            , viewMethodSelected: ko.observable("periods")
            , dateLevels: ko.observableArray([])
            , dateLevelSelected: ko.observable("day")
            , dailyDateLevels: ko.observableArray([])
            , dailyDateLevelSelected: ko.observable("day")
            , graphs: ko.observableArray([])
            , dateGraphs: ko.observableArray([])
            , isChartLoading: ko.observable(0)
            , hasGoogleOverviewReportReadPermission: ko.observable(false)
            , isVisibleComparisonDates: ko.observable(false)
            , selectedRows: ko.observableArray([])
            , onToggleComparisonDates: function(data, event){

                huit_neuf_this.onToggleComparisonDates(data, event);
            }
            , onViewModeChange: function (data) {
                huit_neuf_this.onViewModeChange(data);
            }
            , onViewMethodChange: function (data){
                huit_neuf_this.onViewMethodChange(data);
            }
            , onDateLevelChange: function (data){
                huit_neuf_this.onDateLevelChange(data);
            }
            , onDailyDateLevelChange: function (data){
                huit_neuf_this.onDailyDateLevelChange(data);
            }
            , onClickRowClick: function(index, data){
                huit_neuf_this.onClickRowClick(index);
                return true;
            }
        };
    }

    public getViewModelForRequest() {

        return {
            brands: this.getTemplateViewModel().filterBrands.selectedItems(),
            sources: this.getTemplateViewModel().filterSources.selectedItems(),
            dateFilterType: this.getTemplateViewModel().filterDates.selectedFilter(),
            startDate: this.getTemplateViewModel().filterDates.startDate(),
            endDate: this.getTemplateViewModel().filterDates.endDate(),
            startDateRange: this.getTemplateViewModel().filterDates.fromRange(),
            endDateRange: this.getTemplateViewModel().filterDates.toRange(),
            isCompararisonDatesEnabled: this.getTemplateViewModel().isVisibleComparisonDates(),
            comparisonDateFilterType: this.getTemplateViewModel().filterComparisonDates.selectedFilter(),
            comparisonDateStart: this.getTemplateViewModel().filterComparisonDates.startDate(),
            comparisonDateEnd: this.getTemplateViewModel().filterComparisonDates.endDate(),
            comparisonDateStartDateRange: this.getTemplateViewModel().filterComparisonDates.fromRange(),
            comparisonDateEndDateRange: this.getTemplateViewModel().filterComparisonDates.toRange(),
            dateLevel: this.getTemplateViewModel().dateLevelSelected(),
            dailyDateLevel: this.getTemplateViewModel().dailyDateLevelSelected(),
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            viewMethod: this.getTemplateViewModel().viewMethodSelected(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }

    public buildDatePickerCalendar() {

        this.filterDates.buildCalendar();
        this.filterComparisonDates.buildCalendar();
    }

    public setBrandsFilterItems(departments) {

        let groups = [];
        for (let department of departments) {

            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.filterBrands.setMultiSectionItems(groups);
        this.filterBrands.setLabel('Brands');
    }

    public setSourcesFilterItems(items){

        this.filterSources.setItems(items);
        this.filterSources.setLabel('Sources');
    }

    public setViewModesItems() {

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setViewMethodsItems(){

        this.getTemplateViewModel().viewMethods(this.viewMethods);
    }

    public setDateLevelsItems(){

        if (this.getTemplateViewModel().viewModeSelected() == 'comparison' && this.getTemplateViewModel().viewMethodSelected() == 'aggregated'){

            // Only the 'Day' view method is enabled for the aggregated comparison view.
            this.getTemplateViewModel().dateLevels([this.dateLevels[0]]);

            // Force this selection, since it's the only choice
            this.getTemplateViewModel().dateLevelSelected('day');
        } else{

            this.getTemplateViewModel().dateLevels(this.dateLevels);
            this.getTemplateViewModel().dailyDateLevels(this.dateLevels);
        }
    }

    public setDefaultDates(maxSearchConsoleDate) {

        let dateEnd = new Date(maxSearchConsoleDate);

        let dateStart = new Date(maxSearchConsoleDate);
        dateStart.setTime(dateStart.getTime() - ((24*60*60*1000) * 28));

        let comparisonDateEnd = new Date();
        comparisonDateEnd.setTime(dateStart.getTime() - ((24*60*60*1000)));
        let comparisonDateStart = new Date();
        comparisonDateStart.setTime(comparisonDateEnd.getTime() - ((24*60*60*1000) * 28));

        this.filterDates.setDateRange(dateStart, dateEnd);
        this.filterComparisonDates.setDateRange(comparisonDateStart, comparisonDateEnd);
    }

    public onToggleComparisonDates(data, event){

        this.getTemplateViewModel().isVisibleComparisonDates((event.target.checked) ? 1 : 0);
        this.caller.getListData();
    }

    private onViewModeChange(selectedTemplate) {

        this.caller.getListData();
    }

    private onViewMethodChange(selectedTemplate){

        this.setDateLevelsItems();
        this.caller.getListData();
    }

    private onDateLevelChange(data){

        this.caller.getListData();
    }


    private onDailyDateLevelChange(data){

        this.caller.getListData();
    }

    public setHeader(data) {

        this.getTemplateViewModel().headers(data);
    }

    public setTableData(data) {

        this.getTemplateViewModel().tableData(data);
    }

    public setHasGoogleOverviewReportReadPermission(permission){

        this.getTemplateViewModel().hasGoogleOverviewReportReadPermission(permission);
    }

    /**
     * Convert a string into a colour. Used to pick a colour procedurally when a chart has a variable number of lines.
     */
    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    private padInteger(number: number, size: number)
    {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public updateTrendsGraphData(graphLinesInfo, data){

        let graph = new amCharts_v4_date_line_template("trendsChart", this.getTemplateViewModel(), this.caller)

        let graphData = [];


        if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

            var date24 = new Date();
            date24.setDate(date24.getDate() - 1);

            var date48 = new Date();
            date48.setDate(date48.getDate() - 2);

            let Date24 = date24.getFullYear() + '-' + this.padInteger((date24.getMonth() + 1), 2) + '-' + this.padInteger(date24.getDate(), 2);
            let Date48 = date48.getFullYear() + '-' + this.padInteger((date48.getMonth() + 1), 2) + '-' + this.padInteger(date48.getDate(), 2);



            // ddd if day view
            for (let dateData of data) {

                if (dateData.date == Date24) {

                    let newDateData = {};
                    newDateData["date"] = dateData.date,
                    Object.keys(dateData).forEach(function(key) {
                        newDateData[key+"Yesterday"] = dateData[key];
                    })

                    console.log(newDateData);
                    graphData.push(newDateData);

                } else if (dateData.date == Date48) {

                    let newDateData = {};
                    newDateData["date"] = dateData.date,
                        Object.keys(dateData).forEach(function(key) {
                            newDateData[key+"Yesterday"] = dateData[key];
                        })

                    graphData.push(newDateData);

                    graphData.push(dateData);

                } else {

                    graphData.push(dateData);
                }
            }
        }else {

            graphData = data;
        }

        graph.setDate("date");

        graph.setDisableClickableLegend(1);
        graph.setAutoRotateLabels(1);
        graph.setLabelMaxWidth(80);
        graph.setEnableXScrollbar(1);

        let yaxis = [];
        for (let graphLineInfo of graphLinesInfo){

            let colour = googleOverview_template.stringToColour(graphLineInfo.field);

            yaxis.push({
                field: graphLineInfo.field,
                tooltipfield: graphLineInfo.field,
                name: graphLineInfo.name,
                axis: "main",
                color: colour,
                opposite: false,
            });

            if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

                yaxis.push({
                    field: graphLineInfo.field + "Yesterday",
                    tooltipfield: graphLineInfo.field + "Yesterday",
                    name: graphLineInfo.name + " (Fresh)",
                    axis: "main",
                    color: colour,
                    strokeDasharray: "4,4,4,4",
                    patternFill: true,
                    opposite: false,
                });
            }
        }

        graph.setYaxis(yaxis);

        let dateGraphs = [];

        dateGraphs[0] = {
            'graph': graph
        };

        this.getTemplateViewModel().dateGraphs(dateGraphs);

        let chart = dateGraphs[0]['graph'].drawChart(graphData);

        this.customizeTrendsChart(chart);
    }

    private showPreviousAndFutureWeekdayComparison(chart, clickedRanges, dateAxis, seriesValueFieldName, event){

        for (let range of clickedRanges){

            dateAxis.axisRanges.removeValue(range);
        }

        let dataContext = event.target.dataItem.component.tooltipDataItem.dataContext;
        let dataFields = event.target.dataItem.component.dataFields;
        let clickedDateFieldName = dataFields.dateX;
        let clickedDate = new Date(dataContext[clickedDateFieldName]);
        let clickedValues = {};

        for (let i = 0; chart.data.length != i; i++){

            let candidateDate = new Date(chart.data[i][clickedDateFieldName]);
            if (candidateDate.getTime() == clickedDate.getTime()){

                for (let serieValueFieldName of seriesValueFieldName){

                    clickedValues[serieValueFieldName] = chart.data[i][serieValueFieldName];
                }
            }
        }

        let highlightStart = new Date(dataContext[clickedDateFieldName]);
        highlightStart.setDate(highlightStart.getDate());

        let highlightEnd = new Date(dataContext[clickedDateFieldName]);
        highlightEnd.setDate(highlightEnd.getDate() + 1);

        var clickedRange = dateAxis.axisRanges.create();
        clickedRange.date = highlightStart;
        clickedRange.endDate = highlightEnd;
        clickedRange.axisFill.fill = am4core.color("#1886ff");
        clickedRange.axisFill.fillOpacity = 0.3;
        clickedRange.grid.strokeOpacity = 0;

        clickedRanges.push(clickedRange);

        for (let i = 0; chart.data.length != i; i++){

            let candidateString = chart.data[i].date;
            let candidate = new Date(candidateString);
            let daysDiff = Math.ceil((candidate.getTime() - clickedDate.getTime()) / (1000 * 60 * 60 * 24));

            for (let serieValueFieldName of seriesValueFieldName){

                chart.data[i][serieValueFieldName + '-percentageDiff'] = null;
            }

            if (daysDiff != 0 && daysDiff % 7 == 0){

                let highlightStart = new Date(candidateString);
                highlightStart.setDate(highlightStart.getDate());

                let highlightEnd = new Date(candidateString);
                highlightEnd.setDate(highlightEnd.getDate() + 1);

                for (let serieValueFieldName of seriesValueFieldName){

                    let percentageDiffFieldName = serieValueFieldName + '-percentageDiff';
                    let clickedValue = clickedValues[serieValueFieldName];

                    let relativeChangeText = 'N/A';
                    if (clickedValue != 0 && clickedValue != null){

                        let relativeChange = ((chart.data[i][serieValueFieldName] - clickedValue) / clickedValue) * 100;
                        relativeChangeText = relativeChange.toFixed(1) + '%';
                        if (relativeChange > 0){

                            relativeChangeText = '+' + relativeChangeText;
                        }
                    }

                    chart.data[i][percentageDiffFieldName] = relativeChangeText;
                }

                let range = dateAxis.axisRanges.create();
                range.date = highlightStart;
                range.endDate = highlightEnd;
                range.axisFill.fill = am4core.color("#1886ff");
                range.axisFill.fillOpacity = 0.15;
                range.grid.strokeOpacity = 0;

                clickedRanges.push(range);

                chart.data = chart.data;
            }
        }
    }

    private addPaddingOnLabel(serie, type, target){

        let fieldName = serie.dataFields.valueY + '-percentageDiff';

        if (!target.dataItem){

            return 0;
        }

        if (target.dataItem.dataContext[fieldName] != null){

            return 10;
        }

        return 0;
    }

    private showPreviousWeekDayOnChart(chart, series, dateAxis, seriesValueFieldName){

        let huitneufthis = this;
        let clickedRanges = [];

        for (let serie of series){

            for (let bullet of serie.bullets){

                // Make the bullet easier to click by making it bigger when you hover the mouse close to it
                let hoverState = bullet.states.create("hover");
                hoverState.properties.scale = 2;

                // When you click on the bullet
                bullet.events.on("hit", function(event){

                    // The comparison bullets are LabelBullet, so we don't want to trigger an update by clicking those.
                    if (event.target instanceof LabelBullet){

                        return;
                    }
                    huitneufthis.showPreviousAndFutureWeekdayComparison(chart, clickedRanges, dateAxis, seriesValueFieldName, event);
                });
            }

            let percentageDiffBullet = serie.bullets.push(new am4charts.LabelBullet());
            percentageDiffBullet.label.dy = -20;
            percentageDiffBullet.label.fill = am4core.color("#085070");
            percentageDiffBullet.label.fontSize = 14;
            percentageDiffBullet.label.fontWeight = "bold";
            percentageDiffBullet.label.fillOpacity = 0.8;
            percentageDiffBullet.label.background = new am4core.RoundedRectangle();
            percentageDiffBullet.label.background.cornerRadius(2, 2, 2, 2);
            percentageDiffBullet.label.background.fill = am4core.color("#d8f993");
            percentageDiffBullet.label.background.stroke = am4core.color("#085070");
            percentageDiffBullet.label.background.strokeOpacity = 1;
            percentageDiffBullet.label.propertyFields.text = serie.dataFields.valueY + '-percentageDiff';

            percentageDiffBullet.label.adapter.add("paddingTop", function(type, target){

                return huitneufthis.addPaddingOnLabel(serie, type, target);
            });
            percentageDiffBullet.label.adapter.add("paddingBottom", function(type, target){

                return huitneufthis.addPaddingOnLabel(serie, type, target);
            });
            percentageDiffBullet.label.adapter.add("paddingLeft", function(type, target){

                return huitneufthis.addPaddingOnLabel(serie, type, target);
            });
            percentageDiffBullet.label.adapter.add("paddingRight", function(type, target){

                return huitneufthis.addPaddingOnLabel(serie, type, target);
            });

            percentageDiffBullet.label.background.adapter.add("fill", function(type, target){

                let fieldName = serie.dataFields.valueY + '-percentageDiff';

                if (!target.dataItem){

                    return;
                }

                if (target.dataItem.dataContext[fieldName] != null){

                    let fieldValue = target.dataItem.dataContext[fieldName];
                    let intValue = fieldValue.match(/\d+/)[0];

                    if (fieldValue.charAt(0) == '-'){

                        intValue = intValue * -1;
                    }

                    return am4core.color(huitneufthis.getComparisonColour(intValue));
                }

                return;
            });



            serie.segments.template.interactionsEnabled = true;

            // When you click on the line
            serie.segments.template.events.on("hit", function (event){

                huitneufthis.showPreviousAndFutureWeekdayComparison(chart, clickedRanges, dateAxis, seriesValueFieldName, event);
            }, this);
        }
    }

    public updateComparisonPeriodGraphData(data){

        let graph = new amCharts_v4_date_line_template("comparisonPeriodChart", this.getTemplateViewModel(), this.caller)

        let graphData = [];

        if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

            var date24 = new Date();
            date24.setDate(date24.getDate() - 1);

            var date48 = new Date();
            date48.setDate(date48.getDate() - 2);

            let Date24 = date24.getFullYear() + '-' + this.padInteger((date24.getMonth() + 1), 2) + '-' + this.padInteger(date24.getDate(), 2);
            let Date48 = date48.getFullYear() + '-' + this.padInteger((date48.getMonth() + 1), 2) + '-' + this.padInteger(date48.getDate(), 2);



            // ddd if day view
            for (let dateData of data) {

                if (dateData.date == Date24) {

                    graphData.push({
                        "date": dateData.date,
                        "previousDate": dateData.previousDate,
                        "value1Yesterday": dateData.value1,
                        "value2": dateData.value2
                    });

                } else if (dateData.date == Date48) {

                    graphData.push({
                        "date": dateData.date,
                        "previousDate": dateData.previousDate,
                        "value1Yesterday": dateData.value1,
                        "value2": dateData.value2
                    });

                    graphData.push(dateData);

                } else {

                    graphData.push(dateData);
                }
            }
        }else {

            graphData = data;
        }





        graph.setDate("date");

        graph.setDisableClickableLegend(1);
        graph.setAutoRotateLabels(1);
        graph.setLabelMaxWidth(80);
        graph.setEnableXScrollbar(1);

        let yAxes = [];

        yAxes.push({
            field: 'value1',
            tooltipfield: 'value1',
            name: 'Clicks for Date Range',
            axis: "main",
            color: '#0000FF',
            opposite: false,
        });

        if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

            yAxes.push({
                field: 'value1Yesterday',
                tooltipfield: 'value1Yesterday',
                name: 'Clicks for Date Range (Fresh)',
                axis: "main",
                color: '#0000FF',
                strokeDasharray: "4,4,4,4",
                opposite: false,
            });
        }


        if (this.getTemplateViewModel().isVisibleComparisonDates()){

            yAxes.push({
                field: 'value2',
                tooltipfield: 'value2',
                name: 'Clicks for Comparison Date Range',
                axis: "main",
                color: '#FF0000',
                opposite: false,
            });
        }

        graph.setYaxis(yAxes);

        let dateGraphs = [];

        dateGraphs[0] = {
            'graph': graph
        };

        this.getTemplateViewModel().dateGraphs(dateGraphs);

        let chart = dateGraphs[0]['graph'].drawChart(graphData);

        this.customizeComparisonPeriodChart(chart);
    }

    public updateComparisonAggregatedGraphData(graphData){

        let graph = new amCharts_v4_category_line_template("comparisonAggregatedChart", this.getTemplateViewModel(), this.caller)
        graph.setCategory("category");

        graph.setDisableClickableLegend(1);
        graph.setAutoRotateLabels(1);
        graph.setLabelMaxWidth(80);
        graph.setEnableXScrollbar(1);

        let yAxisName = 'Average Clicks by Weekday';

        let yAxes = [];

        yAxes.push({
            field: 'value1',
            tooltipfield: 'value1',
            name: yAxisName,
            axis: "main",
            color: '#0000FF',
            opposite: false,
        });

        if (this.getTemplateViewModel().isVisibleComparisonDates()){

            yAxes.push({
                field: 'value2',
                tooltipfield: 'value2',
                name: yAxisName + ' (Comparison)',
                axis: "main",
                color: '#FF0000',
                opposite: false,
            });
        }

        graph.setYaxis(yAxes);

        let graphs = [];

        graphs[0] = {
            'graph': graph
        };

        this.getTemplateViewModel().graphs(graphs);

        let chart = graphs[0]['graph'].drawChart(graphData);

        this.customizeComparisonAggregatedChart(chart);
    }

    private customizeTrendsChart(chart){

        let dateAxis = chart.xAxes.values[0];
        let series = chart.series.values;

        for (let serie of series){

            serie.stacked = true;
            serie.fillOpacity = 0.5;
        }

        chart.dateFormatter.firstDayOfWeek = new Date(this.getTemplateViewModel().filterDates.startDate()).getDay() + 1;

        if (this.getTemplateViewModel().dateLevelSelected() == 'day'){

            dateAxis.tooltipDateFormat = "EEEE, yyyy-MM-dd";
        }
    }

    private customizeComparisonPeriodChart(chart){

        let dateAxis = chart.xAxes.values[0];
        let series = chart.series.values;
        let seriesValueFieldName = [];

        if (this.getTemplateViewModel().dateLevelSelected() == 'day'){

            dateAxis.tooltipDateFormat = "EEEE, yyyy-MM-dd";
        }

        chart.dateFormatter.firstDayOfWeek = new Date(this.getTemplateViewModel().filterDates.startDate()).getDay() + 1;
        this.calculateDateRangesForTooltip(chart);

        for (let serie of series){

            this.setShareToolTipForSerie(this, chart, serie);

            if(serie.dataFields.valueY == 'value2'){

                serie.strokeWidth = 2;
                serie.strokeDasharray = "3,4";
                this.calculateDayDiffForTooltip(chart);
            }

            seriesValueFieldName.push(serie.dataFields.valueY);
        }

        if (this.getTemplateViewModel().dateLevelSelected() == 'day' && !this.getTemplateViewModel().isVisibleComparisonDates()){

            this.showPreviousWeekDayOnChart(chart, series, dateAxis, seriesValueFieldName)
        }
    }

    private getEndDateRange(dateString){

        let date = new Date(dateString);
        let dateEnd = new Date(dateString);

        switch(this.getTemplateViewModel().dateLevelSelected()){

            case 'week':

                dateEnd.setTime(date.getTime() + ((24*60*60*1000) * 6));
                break;

            case 'month':

                dateEnd.setMonth(dateEnd.getMonth() + 1);
                dateEnd.setTime(dateEnd.getTime() - (24*60*60*1000));
                break;
        }

        return {dateStart: date, dateEnd: dateEnd}
    }

    private calculateDateRangesForTooltip(chart) {

        let absoluteEndDate = new Date(this.getTemplateViewModel().filterDates.endDate());
        let absoluteEndComparisonDate = new Date(this.getTemplateViewModel().filterComparisonDates.endDate());

        for (let i = 0; chart.data.length != i; i++){

            let dateRange = this.getEndDateRange(chart.data[i]['date']);
            chart.data[i]['dateRangeEnd'] = (absoluteEndDate < dateRange.dateEnd) ? absoluteEndDate : dateRange.dateEnd.toISOString().split('T')[0];

            if (this.getTemplateViewModel().isVisibleComparisonDates()){

                let comparisonDateRange = this.getEndDateRange(chart.data[i]['previousDate']);
                chart.data[i]['comparisonDateRangeEnd'] = (absoluteEndComparisonDate < comparisonDateRange.dateEnd) ? absoluteEndComparisonDate : comparisonDateRange.dateEnd.toISOString().split('T')[0];
            }
        }
    }

    private calculateDayDiffForTooltip(chart){

        for (let i = 0; chart.data.length != i; i++){

            let dayDiff = 'N/A';
            let dayDiffColour = '#1c1c1c'

            let value1 = 0;
            if (chart.data[i].hasOwnProperty("value1Yesterday")) {

                value1 = chart.data[i]['value1Yesterday']
            }else {

                value1 = chart.data[i]['value1'];
            }



            let value2 = chart.data[i]['value2'];

            if (value2 != 0 && value2 != null){

                let value = ((value1 - value2) / value2) * 100;
                dayDiffColour = this.getComparisonColour(value);
                dayDiff = value.toFixed(1) + '%';
                if (value > 0){

                    dayDiff = '+' + dayDiff;
                }
            }

            chart.data[i]['dayDiff'] = dayDiff;
            chart.data[i]['dayDiffColour'] = dayDiffColour;
        }
    }

    private comparisonHtmlTooltip(chart, html){

        html = "<div style='text-align: left'>";
        html += "<div style='display:flex;'><div style='font-size: 16px;margin-right: 5px;'>Clicks</div>";
        html += '<div style="color: {dayDiffColour};font-size: 16px;">{dayDiff}</div></div>';
        let huitneufthis = this;

        chart.series.each(function (item){
            if (!item.isHidden && item.dataFields.valueY !== "value1Yesterday"){

                html += '<div><span style="color: ' + item.stroke.hex + '">●</span> ';// + item.name;

                if (chart.xAxes.values[0] instanceof DateAxis){

                    let dateField = 'dateX';
                    let dateRangeEndField = 'dateRangeEnd';

                    if (item.dataFields.valueY == 'value2'){

                        dateField = 'previousDate';
                        dateRangeEndField = 'comparisonDateRangeEnd';
                    }

                    let dateRange = '';
                    switch (huitneufthis.getTemplateViewModel().dateLevelSelected()){

                        case 'day':

                            dateField = "{" + dateField + ".formatDate('EEEE, yyyy-MM-dd')}";
                            dateRange = dateField;
                            break;

                        case 'week':
                        case 'month':

                            dateField = "{" + dateField + ".formatDate('yyyy-MM-dd')}";
                            dateRange = dateField + " to {" + dateRangeEndField + ".formatDate('yyyy-MM-dd')}";
                            break;
                    }

                    html += " " + dateRange;
                }

                if (item.dataFields.valueY == 'value1') {

                    html += ': {' + item.dataFields.valueY + '}{value1Yesterday}</div>';
                }else {

                    html += ': {' + item.dataFields.valueY + '}</div>';
                }
            }
        });

        html += "</div>";

        return html;
    }

    private setShareToolTipForSerie(huitneufthis, chart, serie){

        serie.tooltip.getFillFromObject = false;
        serie.tooltip.background.fill = am4core.color('#FFFFFF');
        serie.tooltip.label.fill = am4core.color('#1c1c1c');
        serie.tooltip.background.stroke = am4core.color('#085070');
        serie.tooltip.label.fillOpacity = 0.8;
        serie.tooltip.label.fontSize = 12;
        serie.tooltip.label.padding = 12;
        serie.tooltip.label.textAlign = 'start';

        chart.cursor.maxTooltipDistance = -1;
        serie.adapter.add("tooltipHTML", function (html){

            return huitneufthis.comparisonHtmlTooltip(chart, html);
        });
    }
    private customizeComparisonAggregatedChart(chart){

        let series = chart.series.values;

        for (let serie of series){

            this.setShareToolTipForSerie(this, chart, serie);

            if(serie.dataFields.valueY == 'value2'){

                serie.strokeWidth = 2;
                serie.strokeDasharray = "3,4";

                this.calculateDayDiffForTooltip(chart);
            }
        }
    }

    private getComparisonColour(value){

        let colour = '';

        if (value >= 10){

            colour = '#33D075';
        } else if (value >= 0){

            colour = '#83cdb1';
        } else if (value < -10){

            colour = '#ff305c';
        } else if (value < 0){

            colour = '#fc6f35';
        }

        return colour;
    }

    public resetData(){

        this.setHeader([]);
        this.setTableData([]);
        this.getTemplateViewModel().dateGraphs([]);
        this.getTemplateViewModel().graphs([]);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.filterBrands, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterSources, params['sources']);

        this.presetFilter.setDates(this.filterDates, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        this.presetFilter.setDates(this.filterComparisonDates, params['comparisonDateFilterType'], params['comparisonDateStart'], params['comparisonDateEnd'], params['comparisonDateStartDateRange'], params['comparisonDateEndDateRange']);

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
        }

        if(typeof params['viewMethod'] !== 'undefined'){

            this.getTemplateViewModel().viewMethodSelected(params['viewMethod']);
        }

        if(typeof params['dateLevel'] !== 'undefined'){

            this.getTemplateViewModel().dateLevelSelected(params['dateLevel']);
        }

        if(typeof params['dailyDateLevel'] !== 'undefined'){

            this.getTemplateViewModel().dailyDateLevelSelected(params['dailyDateLevel']);
        }

        if(typeof params['isCompararisonDatesEnabled'] !== 'undefined'){

            this.getTemplateViewModel().isVisibleComparisonDates(params['isCompararisonDatesEnabled']);
        }
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/googleOverview_template.ts